// Angular
import { Component, OnInit, OnChanges, Input } from '@angular/core';
// Services
import { ApiService } from './../../services/api';
import { ElasticService } from './../../services/elastic';
// External
import * as lodash from 'lodash';
import { environment } from './../../../environments/environment'
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
    selector: 'app-user-select-modal',
    templateUrl: './user-select-modal.component.html',
    styleUrls: ['./user-select-modal.component.scss']
})

export class UserSelectModalComponent implements OnInit, OnChanges {

    @Input() tournamentId: string;
    @Input() clubName: string;
    @Input() cid: string;
    public query: string;
    public users: Array<any>;

    private typingDelay: any;
    public selectedUsers: Array<any>
    public alreadySelected: Array<any>
    public notify = {
        body: "",
        title: "Golfhubber",
        users: {},
        type: 19,
        cid: this.cid,
        tournament: this.tournamentId

    }
    constructor(private apiService: ApiService, private fireDatabase: AngularFireDatabase, private elasticService: ElasticService) {
        this.query = '';
        this.selectedUsers = []
    }

    ngOnInit() {

        this.query = '';
        this.apiService.object("tournaments/" + this.tournamentId).then((res) => {
            this.alreadySelected = []

            lodash.forEach(res.enteries, (item, key) => {
                if (item) {
                    this.alreadySelected.push(key)
                }

            })
            this.searchMention();

        })
    }


    ngOnChanges() {
    }

    searchMention() {
        const queryParams = {
            'index': 'users',
            'type': 'user',
            'body/query/bool/must/query_string/query': `${this.query}*`,
            'body/query/bool/must/query_string/fields': ['fullName^10', 'username^2']
        };

        this.elasticService.search(queryParams)
            .then(result => {
                this.users = [];
                if (result&&result['hits']) {
                    lodash.forEach(result['hits'], item => {
                        const user = lodash.assign({ $key: item['_id'] }, item['_source']);
                        if (this.alreadySelected.findIndex(id => id == user.$key) == -1) {
                            user.isSelected = this.selectedUsers.findIndex(id => id == user.$key) != -1
                            this.users.push(user);

                        }
                    });
                }

            })
            .catch(error => {
                console.error(error);
            });
    }

    changeQuery() {
        clearTimeout(this.typingDelay);

        this.typingDelay = setTimeout(() => {
            this.searchMention();
            console.log("change")
        }, 400);
    }

    inviteUser(user) {
        if (!user.isSelected) {
            this.selectedUsers.push(user.$key)

            user.isSelected = true

        } else {
            user.isSelected = false

            let i = this.selectedUsers.findIndex(id => id == user.$key)
            this.selectedUsers.splice(i, 1)

        }
        console.log(this.selectedUsers)
    }

    public submit() {
        console.log(this.tournamentId)
        if (this.selectedUsers && this.selectedUsers.length == 0) {
            alert('Please select atleast one player')
            return
        }
        if (confirm('Are you sure, you want to add this player?')) {
            var update = {}
            var users = {}
            console.log(this.selectedUsers)
            for (let k = 0; k < this.selectedUsers.length; k++) {
                const element = this.selectedUsers[k];
                update[`/user-tournaments/${element}/${this.tournamentId}`] = 1
                update[`/tournament-followings/${this.tournamentId}/followings/${element}`] = null;
                update[`/tournaments/${this.tournamentId}/enteries/${element}`] = true
                update[`/user-tournament-scorecard-appversion/${element}/${this.tournamentId}`] = {
                    "userType": "2",
                    "appType": 1,
                    "versionName": environment.version + "",
                    "versionCode": environment.version + "",
                    "platformType": "3",
                    "osVersion": navigator.platform,
                    "brandName": navigator.vendor,
                    "modelName": navigator.userAgent,
                    "imei": "",
                    "createdAt": new Date().getTime() / 1000
                }
                users[element] = true

            }
            this.notify = {
                body: "Golfhubber added you in a tournament",
                title: "Golfhubber",
                users: users,
                type: 19,
                cid: this.cid,
                tournament: this.tournamentId

            }
            update["server-process/admin-notification/" + new Date().getTime() + "/" + new Date().getTime()] = this.notify
            console.log(update)
            this.apiService.bulkUpdate(update)
                .then(() => {
                    $('#invite-users').modal('hide');
                    // location.reload()
                    this.selectedUsers = []
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
    public close(){
        this.query=""
        this.changeQuery()
    }
}
